import TradeSummary from "./TradeSummary";
import Search from "./Search";

const Report = () => {
  return (
    <>
      <div className="page-header">
        <div className="page-title">
          <h2>Raporlama</h2>
        </div>
      </div>
      <div className="page-content">
        <TradeSummary />
        <Search />
      </div>
    </>
  );
};
export default Report;
